@if (showWithLayout) {
  @defer (on idle) {
    <app-cookie-consent />
    <app-notification />
  }

  @if (showShell) {
    <app-header></app-header>
  }

  <div [@routeAnimations]="getRouteAnimationData()" class="main-content">
    @if (notFound) {
      @defer (when notFound) {
        <app-error404></app-error404>
      } @placeholder {
        <div></div>
      }
    } @else {
      @if (enableMainRouting) {
        <router-outlet></router-outlet>
      }
      <router-outlet name="modal"></router-outlet>
      <router-outlet name="sideBar"></router-outlet>
    }
  </div>
  @if (showShell) {
    <div style="min-height: 1px">
      @defer (on viewport) {
        <app-footer />
      } @placeholder {
        <div></div>
      }
      @if (!this.partner?.length) {
        @defer (on idle) {
          <app-melibo />
        }
      }
    </div>
  }
}
